// if the window has a __staticVariantsTrimmed property, it means that the page html comes from the server, otherwise it is fully client side rendered
declare global {
  interface Window {
    __staticVariantsTrimmed?: boolean
  }
}

export const isClientSideVariantSelection = () =>
  typeof window !== 'undefined' && window.__staticVariantsTrimmed === undefined
export const isHtmlRenderVariantSelection = () =>
  typeof window !== 'undefined' && window.__staticVariantsTrimmed === false
export const isEdgeVariantSelection = () =>
  typeof window !== 'undefined' && window.__staticVariantsTrimmed === true
export const resetToClientSideVariantSelection = () =>
  typeof window !== 'undefined' && (window.__staticVariantsTrimmed = undefined)
